import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { CacheFactory, CacheStore, fromMinutesToMilliseconds, StorageMode } from "@obg/ngx.global";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { GameResponse } from "../../game/game.model";

import { FavouriteGamesConfigService } from "./favourite-games.config";

@Injectable({
	providedIn: "root",
})
export class FavouriteGamesService {
	private cache: CacheStore;
	private readonly cacheKey = "favourite-games";

	constructor(
		private httpClient: CoreHttpClient,
		private config: FavouriteGamesConfigService,
		cacheFactory: CacheFactory
	) {
		this.cache = cacheFactory.get("gaming.favourite-games:mem", {
			storageMode: StorageMode.Memory,
			isLanguageSpecific: true,
		});
	}

	getAll(): Observable<string[]> {
		return this.cache.getOrSetAsObservable(
			this.cacheKey,
			() =>
				this.httpClient.get<GameResponse[]>({ url: this.config.getAllEndpoint() }).pipe(
					map((games) =>
						games
							.map((game) => game.id)
							.filter((id) => !this.config.getGameIdsHiddenFromFavourites().includes(id))
					),
					map((favouriteGames) => favouriteGames)
				),
			{ maxAge: fromMinutesToMilliseconds(this.config.getCacheMaxAgeForGetAll()) }
		);
	}

	add(id: string): Observable<string> {
		return this.httpClient.put<string>({
			url: this.config.addRemoveEndpoint(),
			data: { id },
		});
	}

	remove(id: string): Observable<unknown> {
		return this.httpClient.delete<unknown>({
			url: this.config.addRemoveEndpoint(),
			data: { id },
		});
	}

	clearCache(): Promise<void> {
		return this.cache.removeItem(this.cacheKey);
	}
}
